import { render } from "./Animation.vue?vue&type=template&id=cab25fb4&scoped=true"
import script from "./Animation.vue?vue&type=script&lang=js"
export * from "./Animation.vue?vue&type=script&lang=js"

import "./Animation.vue?vue&type=style&index=0&id=cab25fb4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cab25fb4"]])

export default __exports__